<template>
  <v-list-item v-if="groupColor" class="pa-0 border hover-list-element" height="45px">
    <v-row no-gutters class="justify-center align-center">
      <v-col cols="5">
        <v-list-item-content>
          <v-list-item-title class="text-left pl-5 text-truncate font-weight-regular">
            <v-chip
              :color="groupColor"
              small
              :class="{ 'white--text': !isColorLight, 'font--text': isColorLight, 'chip--outlined': isColorWhite }"
              style="height: 20px"
            >
              {{ groupName }}
            </v-chip>
          </v-list-item-title>
        </v-list-item-content>
      </v-col>
      <v-spacer></v-spacer>
      <v-col :cols="isVectorLayer ? 7 : 4">
        <v-row no-gutters class="justify-center align-center">
          <v-col>
            <v-row class="justify-center align-center" no-gutters>
              <v-col :cols="isVectorLayer ? 8 : 'auto'">
                <component
                  @input="updateValue('main_value', $event)"
                  :is="permissionTypeComponent"
                  v-bind="$props"
                  :value="value.main_value"
                ></component>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="isVectorLayer">
            <v-row class="justify-center" no-gutters>
              <v-col cols="auto">
                <permissions-checkbox
                  :disabled="value.main_value === 0"
                  v-bind="$props"
                  @input="updateValue('attachments_and_comments_value', $event)"
                  :value="value.attachments_and_comments_value"
                ></permissions-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-list-item>
</template>

<script>
import { get } from 'vuex-pathify';

import PermissionsSelect from '@/components/PermissionsSelect';
import PermissionsCheckbox from '@/components/PermissionsCheckbox';

export default {
  name: 'LayerAddingPermissionsListItem',
  components: {
    PermissionsSelect,
    PermissionsCheckbox,
  },
  props: {
    group_id: {
      type: [Number, String],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    groupName: get('users/groups@:group_id@name'),
    groupColor: get('users/groups@:group_id@color'),
    isVectorLayer() {
      return this.type === 'features_layer';
    },
    permissionTypeComponent() {
      return this.isVectorLayer ? 'PermissionsSelect' : 'PermissionsCheckbox';
    },
    isColorLight() {
      return this.$_isHexColorLight(this.groupColor);
    },
    isColorWhite() {
      return this.$_getHexColorBrightness(this.groupColor) > 250;
    },
  },
  methods: {
    updateValue(key, value) {
      this.$emit('input', { ...this.value, [key]: value });
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  @include border(top);
  @include border(left);
  @include border(right);
  &:last-child {
    @include border(bottom);
  }
}
.chip--outlined {
  border: 1px solid grey !important;
}
</style>
